// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3eto0","bigColWidth":"Table_bigColWidth__2nVzp","biggerColWidth":"Table_biggerColWidth__yFji5","row":"Table_row__-1BZ8","col":"Table_col__2LWb7"};